module.exports = __webpack_public_path__ + "static/media/kate.21377d7e.jpg";